exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".FiveBlockLinksForDriving-a:hover{-webkit-transition:all .15s;transition:all .15s}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/sass-loader/lib/loader.js!./src/components/contents/FiveBlockLinksForDriving/FiveBlockLinksForDriving.l.scss
// module id = 924
// module chunks = 26